<template>
    <span id="alertcontainer">
        <sweet-modal :icon="type" :ref="uuid" overlay-theme="light" v-on:close="closeHandler"> 
            <div v-html="message" class="alertmessage"></div>
        </sweet-modal>
    </span>
</template>
<script>

import { SweetModal } from "sweet-modal-vue";
import { toggleVisibility } from './toggleVisibilityMixin.js';

export default {
    props: {
        type: String,
        message: String,
        closeModal: {
            type: Function,
            default() {
                return null;
            }
        }
    },
    components: {
        SweetModal
    },
    mixins: [toggleVisibility],
    mounted: function(){
        var vm = this;
        this.$nextTick(function(){
            this.$emit("API", { open: this.$refs[this.uuid].open, close: this.$refs[this.uuid].close })
        });
    },
    data: function() {
        return {}
    },
    methods: {
        closeHandler: function(){ //alla chiusura del modal, chiamo closeHandler, che chiama il metodo closeModal passato dal padre
            this.closeModal();
        }
    }
}
</script>

<style>
.sweet-modal-overlay {
    z-index: 9999
}
div.theme-light div.sweet-title {
    color: white; 
    background-color: #3c8dbc;
}

#alertcontainer .sweet-content{
    padding: 32px 64px !important
}

</style>

<style scoped>

#alertcontainer .alertmessage {
    font-size: 16px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/dynamic/modalWrapper/Alert.vue?0ddf1e7c